(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./packages/content-delivery-api-types/src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./packages/content-delivery-api-types/src/blocks.ts":
/*!***********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/blocks.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/cityBikes.ts":
/*!**************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/cityBikes.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountVipType = exports.AccountFormula = exports.AccountStatus = exports.CityBikeDurations = exports.CityBikeAreas = void 0;
var CityBikeAreas;
(function (CityBikeAreas) {
    CityBikeAreas["HELSINKI_ESPOO"] = "helsinki-espoo";
    CityBikeAreas["VANTAA"] = "vantaa";
})(CityBikeAreas = exports.CityBikeAreas || (exports.CityBikeAreas = {}));
var CityBikeDurations;
(function (CityBikeDurations) {
    CityBikeDurations["DAY"] = "day";
    CityBikeDurations["WEEK"] = "week";
    CityBikeDurations["SEASON"] = "season";
})(CityBikeDurations = exports.CityBikeDurations || (exports.CityBikeDurations = {}));
var AccountStatus;
(function (AccountStatus) {
    // HELSINKI-ESPOO STATUS:
    AccountStatus["ACTIVE"] = "active";
    AccountStatus["INACTIVE_NO_VALID_CARD"] = "inactive_no_valid_card";
    AccountStatus["INACTIVE_LOW_BALANCE"] = "inactive_low_balance";
    AccountStatus["INACTIVE_OTHER"] = "inactive_other";
    AccountStatus["INACTIVE_FORBIDDEN"] = "inactive_forbidden";
    AccountStatus["INACTIVE_EXPIRED"] = "inactive_expired";
    AccountStatus["INACTIVE_NO_FORMULA"] = "inactive_no_formula";
    // VANTAA STATUS:
    AccountStatus["NORMAL"] = "Normal";
    AccountStatus["DISABLED"] = "Disabled";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountFormula;
(function (AccountFormula) {
    AccountFormula["DAY"] = "Day";
    AccountFormula["WEEK"] = "Week";
    AccountFormula["SEASON"] = "Year";
})(AccountFormula = exports.AccountFormula || (exports.AccountFormula = {}));
var AccountVipType;
(function (AccountVipType) {
    AccountVipType[AccountVipType["DAY"] = 91] = "DAY";
    AccountVipType[AccountVipType["WEEK"] = 71] = "WEEK";
    AccountVipType[AccountVipType["SEASON"] = 5] = "SEASON";
})(AccountVipType = exports.AccountVipType || (exports.AccountVipType = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/compactNotification.ts":
/*!************************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/compactNotification.ts ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/customNewsFeed.ts":
/*!*******************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/customNewsFeed.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/errorCodes.ts":
/*!***************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/errorCodes.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
// Error codes that API calls may return in the response Body (they are originally from HSLID):
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["EMAIL_EXISTS"] = "email-exists";
    ErrorCodes["EMAIL_INVALID"] = "email-invalid";
    ErrorCodes["MOBILE_EXISTS"] = "contactNotUnique";
    ErrorCodes["MOBILE_INVALID_REQUEST"] = "invalidRequest";
    ErrorCodes["MOBILE_INVALID_CHANGE"] = "invalidChange";
    ErrorCodes["MOBILE_USER_NOT_FOUND"] = "user-not-found";
    ErrorCodes["MOBILE_INVALID_CODE"] = "invalidCode";
    ErrorCodes["MOBILE_CONTACT_NOT_UNIQUE"] = "contactNotUnique";
    ErrorCodes["MOBILE_SEND_LIMIT_REACHED"] = "sendLimitReached";
    ErrorCodes["SCREEN_NAME_IN_USE"] = "screenname-in-use";
    ErrorCodes["SCREEN_NAME_REQUIREMENTS_NOT_MET"] = "screenname-requirements-not-met";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/favourites.ts":
/*!***************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/favourites.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouritePlaceIcon = void 0;
var FavouritePlaceIcon;
(function (FavouritePlaceIcon) {
    FavouritePlaceIcon["MARKER"] = "icon-icon_place";
    FavouritePlaceIcon["HOME"] = "icon-icon_home";
    FavouritePlaceIcon["WORK"] = "icon-icon_work";
    FavouritePlaceIcon["SPORT"] = "icon-icon_sport";
    FavouritePlaceIcon["SCHOOL"] = "icon-icon_school";
    FavouritePlaceIcon["SHOPPING"] = "icon-icon_shopping";
})(FavouritePlaceIcon = exports.FavouritePlaceIcon || (exports.FavouritePlaceIcon = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/features.ts":
/*!*************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/features.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
var Features;
(function (Features) {
    Features["USER_LOGIN"] = "userLogin";
    Features["HEADER_NOTIFICATIONS"] = "headerNotifications";
    Features["NICKNAME"] = "nickName";
    Features["SHARED_LOCAL_STORAGE"] = "sharedLocalStorage";
    Features["COMMENTING"] = "commenting";
    Features["CITY_BIKE_SEASON_ACTIVE"] = "citybikeSeasonActive";
    Features["VANTAA_CITY_BIKES_RENEWING"] = "vantaaCitybikesRenewing";
    Features["NEW_MESSAGE_SETTINGS"] = "newMessageSettings";
    Features["DELETE_HSL_ACCOUNT"] = "deleteHslAccount";
    Features["SEASON_TICKET_CAMPAIGN"] = "seasonTicketCampaign";
    Features["NAVIGATION_SEARCH"] = "navigationSearch";
})(Features = exports.Features || (exports.Features = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/feedback.ts":
/*!*************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/feedback.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CitybikeMunicipalities = exports.TransportationServiceFields = exports.IdentifierTypes = exports.LocationTypes = exports.JourneyInformationFields = void 0;
var JourneyInformationFields;
(function (JourneyInformationFields) {
    JourneyInformationFields["ASCENT_STOP"] = "ascentStop";
    JourneyInformationFields["CARD_NUMBER"] = "cardNumber";
    JourneyInformationFields["DATE"] = "date";
    JourneyInformationFields["EXIT_STOP"] = "exitStop";
    JourneyInformationFields["IDENTIFIER"] = "identifier";
    JourneyInformationFields["LINE"] = "line";
    JourneyInformationFields["LOCATION"] = "location";
    JourneyInformationFields["SERVICE"] = "service";
    JourneyInformationFields["STOPNUMBER"] = "stopnumber";
    JourneyInformationFields["TIME"] = "time";
})(JourneyInformationFields = exports.JourneyInformationFields || (exports.JourneyInformationFields = {}));
var LocationTypes;
(function (LocationTypes) {
    LocationTypes["PARKING"] = "PARKING";
    LocationTypes["MUNICIPALITY"] = "MUNICIPALITY";
    LocationTypes["SALES_LOCATION"] = "SALES_LOCATION";
    LocationTypes["POINT_OF_SALES"] = "POINT_OF_SALES";
    LocationTypes["FREE_TEXT"] = "FREE_TEXT";
    LocationTypes["CITYBIKE_AREA"] = "CITYBIKE_AREA";
})(LocationTypes = exports.LocationTypes || (exports.LocationTypes = {}));
var IdentifierTypes;
(function (IdentifierTypes) {
    IdentifierTypes["CAR_OR_CARRIAGE_NUMBER"] = "CAR_OR_CARRIAGE_NUMBER";
    IdentifierTypes["TICKET_MACHINE_NUMBER"] = "TICKET_MACHINE_NUMBER";
    IdentifierTypes["APPLICATION_INFORMATION"] = "APPLICATION_INFORMATION";
    IdentifierTypes["BICYCLE_NUMBER"] = "BICYCLE_NUMBER";
    IdentifierTypes["CITYBIKE_STATION_NAME"] = "CITYBIKE_STATION_NAME";
})(IdentifierTypes = exports.IdentifierTypes || (exports.IdentifierTypes = {}));
var TransportationServiceFields;
(function (TransportationServiceFields) {
    TransportationServiceFields["ASCENT_STOP"] = "ascentStop";
    TransportationServiceFields["EXIT_STOP"] = "exitStop";
    TransportationServiceFields["IDENTIFIER"] = "identifier";
    TransportationServiceFields["STOPNUMBER"] = "stopnumber";
})(TransportationServiceFields = exports.TransportationServiceFields || (exports.TransportationServiceFields = {}));
var CitybikeMunicipalities;
(function (CitybikeMunicipalities) {
    CitybikeMunicipalities["HELSINKI_ESPOO"] = "Helsinki ja Espoo";
    CitybikeMunicipalities["VANTAA"] = "Vantaa";
})(CitybikeMunicipalities = exports.CitybikeMunicipalities || (exports.CitybikeMunicipalities = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/imagePresets.ts":
/*!*****************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/imagePresets.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreset = void 0;
var ImagePreset;
(function (ImagePreset) {
    ImagePreset["DEFAULT"] = "default";
    ImagePreset["960w"] = "960w";
    ImagePreset["1280w"] = "1280w";
    ImagePreset["1920w"] = "1920w";
    ImagePreset["2560w"] = "2560w";
    ImagePreset["BANNER"] = "1920w";
    ImagePreset["NEWS_FEED"] = "800w";
    ImagePreset["PREVIEW_LINK_ITEM"] = "800w";
    ImagePreset["IMAGE_TEASER"] = "1440w";
    ImagePreset["CONTENT_IMAGE"] = "1340w";
})(ImagePreset = exports.ImagePreset || (exports.ImagePreset = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/index.ts":
/*!**********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/index.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./types */ "./packages/content-delivery-api-types/src/types.ts"), exports);
__exportStar(__webpack_require__(/*! ./primitives */ "./packages/content-delivery-api-types/src/primitives.ts"), exports);
__exportStar(__webpack_require__(/*! ./blocks */ "./packages/content-delivery-api-types/src/blocks.ts"), exports);
__exportStar(__webpack_require__(/*! ./navigation */ "./packages/content-delivery-api-types/src/navigation.ts"), exports);
__exportStar(__webpack_require__(/*! ./pageTemplates */ "./packages/content-delivery-api-types/src/pageTemplates.ts"), exports);
__exportStar(__webpack_require__(/*! ./startPage */ "./packages/content-delivery-api-types/src/startPage.ts"), exports);
__exportStar(__webpack_require__(/*! ./survey */ "./packages/content-delivery-api-types/src/survey.ts"), exports);
__exportStar(__webpack_require__(/*! ./news */ "./packages/content-delivery-api-types/src/news.ts"), exports);
__exportStar(__webpack_require__(/*! ./search */ "./packages/content-delivery-api-types/src/search.ts"), exports);
__exportStar(__webpack_require__(/*! ./features */ "./packages/content-delivery-api-types/src/features.ts"), exports);
__exportStar(__webpack_require__(/*! ./user */ "./packages/content-delivery-api-types/src/user.ts"), exports);
__exportStar(__webpack_require__(/*! ./favourites */ "./packages/content-delivery-api-types/src/favourites.ts"), exports);
__exportStar(__webpack_require__(/*! ./transportation */ "./packages/content-delivery-api-types/src/transportation.ts"), exports);
__exportStar(__webpack_require__(/*! ./imagePresets */ "./packages/content-delivery-api-types/src/imagePresets.ts"), exports);
__exportStar(__webpack_require__(/*! ./feedback */ "./packages/content-delivery-api-types/src/feedback.ts"), exports);
__exportStar(__webpack_require__(/*! ./cityBikes */ "./packages/content-delivery-api-types/src/cityBikes.ts"), exports);
__exportStar(__webpack_require__(/*! ./parking */ "./packages/content-delivery-api-types/src/parking.ts"), exports);
__exportStar(__webpack_require__(/*! ./pointOfSale */ "./packages/content-delivery-api-types/src/pointOfSale.ts"), exports);
__exportStar(__webpack_require__(/*! ./compactNotification */ "./packages/content-delivery-api-types/src/compactNotification.ts"), exports);
__exportStar(__webpack_require__(/*! ./errorCodes */ "./packages/content-delivery-api-types/src/errorCodes.ts"), exports);
__exportStar(__webpack_require__(/*! ./customNewsFeed */ "./packages/content-delivery-api-types/src/customNewsFeed.ts"), exports);
__exportStar(__webpack_require__(/*! ./messageSettings */ "./packages/content-delivery-api-types/src/messageSettings.ts"), exports);
__exportStar(__webpack_require__(/*! ./notifications */ "./packages/content-delivery-api-types/src/notifications.ts"), exports);


/***/ }),

/***/ "./packages/content-delivery-api-types/src/messageSettings.ts":
/*!********************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/messageSettings.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/navigation.ts":
/*!***************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/navigation.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/news.ts":
/*!*********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/news.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/notifications.ts":
/*!******************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/notifications.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/pageTemplates.ts":
/*!******************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/pageTemplates.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/parking.ts":
/*!************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/parking.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ParkTypes = exports.ParkFacilityTypes = void 0;
var ParkFacilityTypes;
(function (ParkFacilityTypes) {
    ParkFacilityTypes["BICYCLE"] = "BICYCLE";
    ParkFacilityTypes["CAR"] = "CAR";
})(ParkFacilityTypes = exports.ParkFacilityTypes || (exports.ParkFacilityTypes = {}));
var ParkTypes;
(function (ParkTypes) {
    ParkTypes["CAR"] = "CAR";
    ParkTypes["ELECTRIC_CAR"] = "ELECTRIC_CAR";
    ParkTypes["BICYCLE"] = "BICYCLE";
    ParkTypes["BICYCLE_SECURE_SPACE"] = "BICYCLE_SECURE_SPACE";
    ParkTypes["DISABLED"] = "DISABLED";
    ParkTypes["MOTORCYCLE"] = "MOTORCYCLE";
})(ParkTypes = exports.ParkTypes || (exports.ParkTypes = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/pointOfSale.ts":
/*!****************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/pointOfSale.ts ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PointOfSaleServiceType = exports.PointOfSaleTypes = void 0;
var PointOfSaleTypes;
(function (PointOfSaleTypes) {
    PointOfSaleTypes[PointOfSaleTypes["UNKNOWN"] = 0] = "UNKNOWN";
    PointOfSaleTypes[PointOfSaleTypes["POINT_OF_SERVICE"] = 1] = "POINT_OF_SERVICE";
    PointOfSaleTypes[PointOfSaleTypes["POINT_OF_SALE"] = 2] = "POINT_OF_SALE";
    PointOfSaleTypes[PointOfSaleTypes["MACHINE_SINGLE_TICKET"] = 3] = "MACHINE_SINGLE_TICKET";
    PointOfSaleTypes[PointOfSaleTypes["MACHINE_MULTI_TICKET"] = 4] = "MACHINE_MULTI_TICKET";
    PointOfSaleTypes[PointOfSaleTypes["MACHINE_PARKING_TICKET"] = 5] = "MACHINE_PARKING_TICKET";
})(PointOfSaleTypes = exports.PointOfSaleTypes || (exports.PointOfSaleTypes = {}));
var PointOfSaleServiceType;
(function (PointOfSaleServiceType) {
    PointOfSaleServiceType[PointOfSaleServiceType["CARD_TOP_UP"] = 1] = "CARD_TOP_UP";
    PointOfSaleServiceType[PointOfSaleServiceType["MANAGE_PERSONAL_CARD"] = 2] = "MANAGE_PERSONAL_CARD";
    PointOfSaleServiceType[PointOfSaleServiceType["MANAGE_MULTI_USER_CARD"] = 11] = "MANAGE_MULTI_USER_CARD";
    PointOfSaleServiceType[PointOfSaleServiceType["DAY_TICKETS_1_TO_7"] = 3] = "DAY_TICKETS_1_TO_7";
    PointOfSaleServiceType[PointOfSaleServiceType["ADVANCE_PURCHASE_SINGLE_TICKETS"] = 4] = "ADVANCE_PURCHASE_SINGLE_TICKETS";
    PointOfSaleServiceType[PointOfSaleServiceType["PAPER_SINGLE_TICKET"] = 5] = "PAPER_SINGLE_TICKET";
    PointOfSaleServiceType[PointOfSaleServiceType["DAY_TICKET_SINGLE_ABC"] = 6] = "DAY_TICKET_SINGLE_ABC";
    PointOfSaleServiceType[PointOfSaleServiceType["COMMUTER_TICKET_AND_GIFT_CARD_SUPPORT"] = 7] = "COMMUTER_TICKET_AND_GIFT_CARD_SUPPORT";
    PointOfSaleServiceType[PointOfSaleServiceType["PAYMENT_BANKNOTES"] = 8] = "PAYMENT_BANKNOTES";
    PointOfSaleServiceType[PointOfSaleServiceType["PAYMENT_COINS"] = 9] = "PAYMENT_COINS";
    PointOfSaleServiceType[PointOfSaleServiceType["PAYMENT_CREDIT_CARDS"] = 10] = "PAYMENT_CREDIT_CARDS";
})(PointOfSaleServiceType = exports.PointOfSaleServiceType || (exports.PointOfSaleServiceType = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/primitives.ts":
/*!***************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/primitives.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoSectionDisplayOption = void 0;
var InfoSectionDisplayOption;
(function (InfoSectionDisplayOption) {
    InfoSectionDisplayOption["Info"] = "Info";
    InfoSectionDisplayOption["CallToAction"] = "CallToAction";
    InfoSectionDisplayOption["Accordion"] = "Accordion";
    InfoSectionDisplayOption["LinkList"] = "LinkList";
})(InfoSectionDisplayOption = exports.InfoSectionDisplayOption || (exports.InfoSectionDisplayOption = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/search.ts":
/*!***********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/search.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/startPage.ts":
/*!**************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/startPage.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/survey.ts":
/*!***********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/survey.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./packages/content-delivery-api-types/src/transportation.ts":
/*!*******************************************************************!*\
  !*** ./packages/content-delivery-api-types/src/transportation.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrafficAnnouncementIcon = exports.TransportaionIcons = exports.TransportMode = exports.TransportationServices = void 0;
var TransportationServices;
(function (TransportationServices) {
    TransportationServices["BUS"] = "BUS";
    TransportationServices["TRAM"] = "TRAM";
    TransportationServices["RAIL"] = "RAIL";
    TransportationServices["SUBWAY"] = "SUBWAY";
    TransportationServices["FERRY"] = "FERRY";
    TransportationServices["CITYBIKE"] = "CITYBIKE";
})(TransportationServices = exports.TransportationServices || (exports.TransportationServices = {}));
var TransportMode;
(function (TransportMode) {
    TransportMode[TransportMode["EXCEPTION"] = 0] = "EXCEPTION";
    TransportMode[TransportMode["BUS"] = 1] = "BUS";
    TransportMode[TransportMode["TRAM"] = 2] = "TRAM";
    TransportMode[TransportMode["RAIL"] = 3] = "RAIL";
    TransportMode[TransportMode["SUBWAY"] = 4] = "SUBWAY";
    TransportMode[TransportMode["FERRY"] = 5] = "FERRY";
    TransportMode[TransportMode["CITYBIKE"] = 6] = "CITYBIKE";
})(TransportMode = exports.TransportMode || (exports.TransportMode = {}));
var TransportaionIcons;
(function (TransportaionIcons) {
    TransportaionIcons["RouteTram"] = "tram-rectangle";
    TransportaionIcons["RouteRail"] = "train-rectangle";
    TransportaionIcons["RouteBus"] = "bus-rectangle";
    TransportaionIcons["RouteSubway"] = "metro-rectangle";
    TransportaionIcons["RouteFerry"] = "ferry-rectangle";
    TransportaionIcons["Stop"] = "stop";
})(TransportaionIcons = exports.TransportaionIcons || (exports.TransportaionIcons = {}));
exports.TrafficAnnouncementIcon = (_a = {},
    _a[TransportMode.BUS] = 'bus-rectangle',
    _a[TransportMode.FERRY] = 'ferry-rectangle',
    _a[TransportMode.SUBWAY] = 'metro-rectangle',
    _a[TransportMode.RAIL] = 'train-rectangle',
    _a[TransportMode.TRAM] = 'tram-rectangle',
    _a[TransportMode.CITYBIKE] = 'citybike-rectangle',
    _a[TransportMode.EXCEPTION] = 'warning',
    _a);


/***/ }),

/***/ "./packages/content-delivery-api-types/src/types.ts":
/*!**********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/types.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
/*
    NotificationType:
    exception = Liikennehäiriöt
    bulletin = Liikennetiedotteet (Uutiset)
*/
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["EXCEPTION"] = 1] = "EXCEPTION";
    NotificationType[NotificationType["BULLETIN"] = 2] = "BULLETIN";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));


/***/ }),

/***/ "./packages/content-delivery-api-types/src/user.ts":
/*!*********************************************************!*\
  !*** ./packages/content-delivery-api-types/src/user.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map